import React from 'react';
import { Bar } from 'react-chartjs-2';
import { Grid } from '@material-ui/core';

import Card from 'src/components/sharedComponents/Card/Card';
import CardBody from 'src/components/sharedComponents/Card/CardBody';
import CardHeader from 'src/components/sharedComponents/Card/CardHeader';
import * as Utils from 'src/utils/chartsUtils';
import TableAA from '../../Tables/TableAA';
import { useStyles } from '../styles';

const TotalMarkersCard = (props) => {
  const { total = [], selectedDate, totalGraphics } = props;
  const classes = useStyles();

  return (
    <Card>
      <CardHeader>
        <div className={classes.center}>
          <div>
            <h3>Evolución Total del Mercado</h3>
          </div>
          {'  '}
        </div>
      </CardHeader>
      <CardBody>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={12} lg={6}>
            <TableAA array={total} selectedDate={selectedDate} disableAA />
          </Grid>
          <Grid item xs={12} sm={12} lg={6}>
            <h3>
              Evolución Total del Mercado en miles -
              {' '}
              {selectedDate.getFullYear()}
            </h3>
            <br />
            <Bar
              data={Utils.simpleBarLine(
                totalGraphics,
                'Y',
                'CANT',
                'VARIACION',
                'Año',
              )}
              options={Utils.optionsSimpleBarChart}
            />
            {' '}
          </Grid>
        </Grid>
      </CardBody>
    </Card>
  );
};

export default TotalMarkersCard;
